import get from 'lodash/get';
import { PCP_PROVIDER_ANSWER } from '../../constants/pcpAnswer';

export const gerPCPData = pcpFormData => {
  if (pcpFormData.pcpProviderAnswer === PCP_PROVIDER_ANSWER.U) {
    return {
      pcp_provider_answer: pcpFormData.pcpProviderAnswer,
      pcp_id: null,
      pcp_name: '',
      consider_us_pcp: false,
    };
  }

  if (pcpFormData.pcpProviderAnswer === PCP_PROVIDER_ANSWER.N) {
    return {
      pcp_provider_answer: pcpFormData.pcpProviderAnswer,
      consider_us_pcp: pcpFormData.considerUsPcp,
      pcp_id: null,
      pcp_name: '',
    };
  }

  return {
    pcp_provider_answer: pcpFormData.pcpProviderAnswer,
    pcp_id: pcpFormData.pcpName
      ? null
      : get(pcpFormData, 'primaryCareProvider.value', null),
    pcp_name: pcpFormData.pcpName,
    consider_us_pcp: pcpFormData.considerUsPcp,
  };
};



// WEBPACK FOOTER //
// ./src/utils/appointments/gerPCPData.js